<template>
    <div class="home">
        <div class="header">
            <device-list @success="getList" @onLoading="onLoading"></device-list>
        </div>
        <div>
        <el-table :data="tableData" stripe style="width: 100%" border size="mini" v-loading="loading">
            <el-table-column align="center" type="index" label="序号" width="50" />
            <el-table-column align="center" prop="kpdwdm" label="税号" min-width="180" />
            <el-table-column align="center" prop="kpdwmc" label="纳税人名称" min-width="180" />
            <el-table-column align="center" prop="jqbh" label="税控盘编号" min-width="180" />
            <el-table-column align="center" prop="zt" label="状态" min-width="180">
                <template #default="scope"><span :style="{'color':(scope.row.zt == '成功'? 'green' : 'red')}">{{ scope.row.zt }}</span></template>
            </el-table-column>
        </el-table>
        </div>
    </div>
</template>

<script>
import { zyTaxDiscStatusList } from "@/api/ea";
import deviceList from './components/deviceList.vue'
export default {
    components: { deviceList },
    data(){
        return{
            tableData:[],
            loading:false
        }
    },
    created(){

    },
    methods:{
        getList(e){
            console.log(e);
            zyTaxDiscStatusList({name:e}).then(res=>{
               if(res.data.msg == "success"){
                    this.loading = false
                    this.tableData = res.data.data.list
                }  
            })
        },
        onLoading(loading){
            console.log(loading);
            this.loading = loading
        }
    }
}
</script>

<style lang="scss" scoped>
</style>